import React, { ReactNode } from 'react'

interface ButtonProps {
  className?: string
  children: ReactNode
  type?: any
  onClick?: (e?: any) => any
  id?: string
  ariaLabel?: any
  role?: any
  tabIndex?: any
}
const Button: React.FC<ButtonProps> = ({
  className,
  children,
  type,
  onClick,
  id,
  ariaLabel,
  role,
  tabIndex,
}) => {
  return (
    <button
      className={`${className} btn btn--primary hover--animation`}
      type={type}
      onClick={onClick}
      id={id}
      aria-label={ariaLabel}
      role={role}
      tabIndex={tabIndex}
    >
      <span className="d-flex justify-content-center align-items-center">
        {children}
      </span>
    </button>
  )
}

export default Button
